
import { apiRequest, userApiRequest } from "../actions/api";
import { LOGIN, LOGOUT, RESETSELFPASSWORD , RESETUSERPASSWORD, DELETEMANAGERUSER, DELETEOPERATORUSER } from "../actions/auth";

//const SERVER_URL = `http://192.168.0.248:5000/api/mgmt/users/search`;
//const SERVER_URL = `http://192.168.0.199/api/login/monitoring`;
//const SERVER_URL = `http://localhost:9000/login/monitoring`;
//const SERVER_URL = `http://192.168.0.199:6010/api/v1/login/monitoring`;

//const SERVER_URL = "/api/login/monitoring";

export const appMiddleware = () => next => action => {
  next(action);
  switch (action.type) {
    case LOGIN: {
      const { email, password, ssoData } = action.payload;
      // console.log("action.payload", action.payload);
      
      next(
        apiRequest({                              
          url: '/api/customers/admin/sso/login',
          method: "POST",
          data: { "sso_data":action.payload.sso_data },
          headers: {            
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
            },
          auth: { "username":action.payload.email, "password":action.payload.password },
        })
      );
      break;
    }
    case LOGOUT: {
      next(
        apiRequest({
          url: '/api/customers/admin/sso/logout',
          method: "POST",
          data: action.payload.userid,
          // headers: {'Content-Type': 'application/json',
          //   data: JSON.stringify({"user_id": action.payload.user_id,
          //                       "role_id":action.payload.role_id,
          //                       "access_token": action.payload.access_token}),
          // }
          headers: {"Authorization" : `Bearer ${action.payload.token || "invalid_token"}`}
        })
      );
      break;
    }
    case RESETSELFPASSWORD: {
      next(
        userApiRequest({                              
          url: `/api/useraccounts/monitoring/users/changepassword/self/${action.payload.userid}`,
          method: "PUT",
          data: {},
          headers: {            
            'Content-Type': 'application/json'
            },
          auth: {"username":action.payload.currentpassword,"password":action.payload.newpassword},
        })
      );
      break;
    }
    case RESETUSERPASSWORD: {
      next(
        userApiRequest({                              
          url: `/api/useraccounts/monitoring/users/changepassword`,
          method: "PUT",
          data: {},
          headers: {            
            'Content-Type': 'application/json'
            },
          auth: {"username":action.payload.email,"password":action.payload.newpassword},
        })
      );
      break;
    }
    case DELETEMANAGERUSER: {
      next(
        userApiRequest({                              
          url: `/api/useraccounts/monitoring/users/manager/${action.payload.userid}`,
          method: "DELETE",
          data: {},
          headers: {            
            'Content-Type': 'application/json'
            },
          
        })
      );
      break;
    }
    case DELETEOPERATORUSER: {
      next(
        userApiRequest({                              
          url: `/api/useraccounts/monitoring/users/operator/${action.payload.userid}`,
          method: "DELETE",
          data: {},
          headers: {            
            'Content-Type': 'application/json'
            },
          
        })
      );
      break;
    }
    default:
      break;
  }


};
